import { render, staticRenderFns } from "./Inventario.vue?vue&type=template&id=33b5f77c&scoped=true&"
import script from "./Inventario.vue?vue&type=script&lang=js&"
export * from "./Inventario.vue?vue&type=script&lang=js&"
import style0 from "./Inventario.vue?vue&type=style&index=0&id=33b5f77c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33b5f77c",
  null
  
)

export default component.exports